/**
 * ==========================================================
 * SpellNexus Preorder Engine
 * ==========================================================
 * Biblioteca de validación de preventas.
 * No registra eventos ni modifica el DOM.
 * ==========================================================
 */

async function getCart() {
  const response = await fetch('/cart.js');
  return await response.json();
}

/**
 * Devuelve true únicamente si el producto sigue siendo una preventa.
 * El mismo día del lanzamiento deja de considerarse preventa.
 */
function isActivePreorder(releaseDate) {

  if (!releaseDate) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const launchDate = new Date(releaseDate);
  launchDate.setHours(0, 0, 0, 0);

  return launchDate > today;
}

function getCartState(cart) {

  const releaseDates = [];

  cart.items.forEach(item => {

    if (
      item.properties &&
      item.properties._release_date &&
      isActivePreorder(item.properties._release_date)
    ) {
      releaseDates.push(item.properties._release_date);
    }

  });

  const uniqueDates = [...new Set(releaseDates)];

  return {

    hasItems: cart.items.length > 0,

    hasPreorders: releaseDates.length > 0,

    releaseDate:
      uniqueDates.length === 1
        ? uniqueDates[0]
        : null,

    hasMixedDates:
      uniqueDates.length > 1

  };

}

function canAddProduct(productReleaseDate, cartState) {

  // Si la fecha ya ha pasado, tratar el producto como uno normal
  if (!isActivePreorder(productReleaseDate)) {
    productReleaseDate = null;
  }

  // Carrito vacío
  if (!cartState.hasItems) {
    return true;
  }

  // Carrito solo productos normales
  if (!cartState.hasPreorders && !productReleaseDate) {
    return true;
  }

  // Carrito con preventas y el producto también es preventa
  if (cartState.hasPreorders && productReleaseDate) {
    return cartState.releaseDate === productReleaseDate;
  }

  // No permitir mezclar preventas y productos normales
  return false;

}

window.SpellNexusPreorder = {
  getCart,
  getCartState,
  canAddProduct,
  isActivePreorder
};